// The country as a grid of equal squares, one a state (rows and columns as
// NPR's tile-grid map lays them out), so every state is as easy to tap as
// every other. DC and the territories send a delegate to the House only.
export const TILES = {
  AK: [0, 0],
  ME: [0, 11],
  VT: [1, 10],
  NH: [1, 11],
  WA: [2, 1],
  ID: [2, 2],
  MT: [2, 3],
  ND: [2, 4],
  MN: [2, 5],
  IL: [2, 6],
  WI: [2, 7],
  MI: [2, 8],
  NY: [2, 9],
  RI: [2, 10],
  MA: [2, 11],
  OR: [3, 1],
  NV: [3, 2],
  WY: [3, 3],
  SD: [3, 4],
  IA: [3, 5],
  IN: [3, 6],
  OH: [3, 7],
  PA: [3, 8],
  NJ: [3, 9],
  CT: [3, 10],
  CA: [4, 1],
  UT: [4, 2],
  CO: [4, 3],
  NE: [4, 4],
  MO: [4, 5],
  KY: [4, 6],
  WV: [4, 7],
  VA: [4, 8],
  MD: [4, 9],
  DE: [4, 10],
  AZ: [5, 2],
  NM: [5, 3],
  KS: [5, 4],
  AR: [5, 5],
  TN: [5, 6],
  NC: [5, 7],
  SC: [5, 8],
  DC: [5, 9],
  OK: [6, 4],
  LA: [6, 5],
  MS: [6, 6],
  AL: [6, 7],
  GA: [6, 8],
  HI: [7, 0],
  TX: [7, 4],
  FL: [7, 9],
  // The territories, in a row of their own under the map
  AS: [8, 0],
  GU: [8, 1],
  MP: [8, 2],
  PR: [8, 3],
  VI: [8, 4],
};
